import React from 'react';
/* 业务组件*/
import {
  CtSection,
  MdBanner,
  MdComplex,
  MdCaseCard,
  CtActionPanel,
} from './components/index.js';
import { MIconsList } from './components/MIconsList';
import { iconsDataDb } from './mock/icons';
import './styles/index.scss';
import './styles/app.scss';

import data from './mock/data.js';

const App = () => {
  return (
    <div>
      <div className="material">
        <MdBanner data={data.bannerData} />
        <CtSection
          className="material-section--mdComplex"
          title="资源包"
          desc="包含腾讯云产品与服务官方图标集。除了提供基础的PNG、SVG格式资源包之外，我们还提供了便于客户直接使用的PPT格式，可以轻松的粘贴到您的文件中。我们将持续补充更多的格式。"
        >
          <MdComplex data={data.MdComplexData} />
        </CtSection>
        <CtSection
          className="bg-gray"
          title="腾讯云产品与服务图标库"
          desc="搜索支持产品中文名（如云服务器）与英文缩略名（如CVM），可在线定制图标颜色以适应架构图的使用环境，提供PNG、SVG格式下载，也可直接复制SVG源码。"
        >
          <MIconsList data={iconsDataDb} />
        </CtSection>
        <CtSection
          className="material-section--mdCaseCard"
          title="架构图在线搭建工具"
          desc="您还可以使用第三方工具协助进行架构图的搭建"
        >
          <MdCaseCard data={data.MtCaseCardData} />
        </CtSection>

        <CtActionPanel
          className="material-actionPanel2"
          data={data.actionPanel}
        />
      </div>
    </div>
  );
};

export default App;
